import { useQuery } from 'react-query';
import { apiCpService } from '@services/apiCpService.ts';

export const FindScenariosQueryKey = 'find-scenarios';

export const useFindScenariosQuery = () =>
  useQuery(FindScenariosQueryKey, async () => {
    const { data } = await apiCpService.getScenariosCpClientScenariosGet();

    return data;
  });
